import React from "react";
import {
  FaUserGraduate,
  FaCheckCircle,
  FaGift,
  FaCertificate,
  FaRobot,
  FaPalette,
  FaFilm,
  FaBrain,
  FaLaptopCode,
  FaDraftingCompass,
  FaPhotoVideo,
  FaBroadcastTower,
  FaBullhorn,
  FaNewspaper,
  FaMagic,
} from "react-icons/fa";
import "../styles/registration-highlights.css";

const RegistrationHighlights = () => {
  const courseData = {
    title: "Chương Trình Đào Tạo Chứng Chỉ Quốc Gia",
    subtitle:
      "Kết hợp Online + Offline - Khai giảng & ôn thi liên tục hằng tháng",
    courses: [
      {
        name: "Thiết kế đồ họa",
        note: "Tích hợp công nghệ AI",
        ai: true,
        icon: FaPalette,
      },
      { name: "Biên tập & Dựng phim", ai: false, icon: FaFilm },
      { name: "Trí tuệ nhân tạo (Ứng dụng)", ai: true, icon: FaBrain },
      {
        name: "Thiết kế Website",
        note: "Công nghệ AI",
        ai: true,
        icon: FaLaptopCode,
      },
      {
        name: "Thiết kế đồ họa Kiến trúc - Nội thất",
        note: "Tích hợp công nghệ AI",
        ai: true,
        icon: FaDraftingCompass,
      },
      {
        name: "Thiết kế Mỹ thuật Đa phương tiện",
        ai: false,
        icon: FaPhotoVideo,
      },
      { name: "Nghiệp vụ Livestream", ai: false, icon: FaBroadcastTower },
      { name: "Digital Marketing", ai: false, icon: FaBullhorn },
      {
        name: "Nghiệp vụ Báo chí / Truyền thông",
        ai: false,
        icon: FaNewspaper,
      },
      {
        name: "Kỹ xảo điện ảnh",
        note: "Tích hợp công nghệ AI",
        ai: true,
        icon: FaMagic,
      },
    ],
  };

  return (
    <section className="registration-section">
      <div className="registration-wrapper">
        {/* KHỐI 1: THÔNG TIN ƯU ĐÃI & AI */}
        <div className="registration-highlights">
          <h3 className="highlights-title">
            <FaUserGraduate className="title-icon" />
            Học viện DESIGN24
          </h3>

          <div className="price-tag-container">
            <span className="price-label">Ưu đãi đặc biệt chỉ với</span>
            <div className="price-value">
              2.800.000đ<span>/học viên</span>
            </div>
          </div>

          <ul className="highlights-list">
            <li>
              <FaCheckCircle className="check-icon" />
              <span>
                Đào tạo và cấp <strong>CHỨNG CHỈ QUỐC GIA</strong>
              </span>
            </li>
            <li>
              <FaCheckCircle className="check-icon" />
              <span>
                Hình thức học linh hoạt: <strong>Online + Offline</strong>
              </span>
            </li>
            <li>
              <FaCheckCircle className="check-icon" />
              <span>Khai giảng & ôn thi liên tục hằng tháng</span>
            </li>
          </ul>

          <div className="highlights-bonus-box">
            <div className="bonus-left">
              <FaGift className="gift-icon" />
              <div className="bonus-info">
                <span className="bonus-qty">TẶNG 24 học viên</span>
                <span className="bonus-target">Đăng ký đầu tiên</span>
              </div>
            </div>

            <div className="bonus-right">
              <p className="bonus-text">
                3 tháng sử dụng{" "}
                <span className="highlight-ai">GOOGLE AI ULTRA</span>
                <br />
                Sử dụng Gemini Pro, tạo ảnh & video không giới hạn...
              </p>
            </div>
          </div>
        </div>

        {/* KHỐI 2: DANH SÁCH KHÓA HỌC */}
        <div className="courses-container">
          <div className="courses-header">
            <h3 className="courses-main-title">
              <FaCertificate className="title-icon" />
              DANH MỤC KHÓA HỌC
            </h3>
            <p className="courses-subtitle">{courseData.subtitle}</p>
          </div>

          <div className="courses-grid">
            {courseData.courses.map((course, index) => {
              const CourseIcon = course.icon;
              return (
                <div
                  className="course-item"
                  key={index}
                >
                  <div className="course-content">
                    <div className="course-icon-wrapper">
                      <CourseIcon className="course-specific-icon" />
                    </div>
                    <div className="course-text">
                      <span className="course-name">{course.name}</span>
                      {course.note && (
                        <span className="course-note">({course.note})</span>
                      )}
                    </div>
                  </div>
                  {course.ai && (
                    <div
                      className="ai-badge"
                      title="Tích hợp AI"
                    >
                      <FaRobot className="ai-badge-icon" />
                      <span>AI</span>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegistrationHighlights;
